<template>
  <v-app>
    <v-container style="background-color:#18A889; padding: 10px 10px 40px 10px; margin-bottom: 20px;">
      <h1 class="display-2 text-xs-center">
        HEALTH & SAFETY
      </h1>
      <h5 class="headline text-xs-center">
        WORKPLACE ASSESSMENT
      </h5>
      <v-card>
        <v-card-title>
          <v-flex xs6>
            <h4>Company:</h4> {{ company.name }}
          </v-flex>
          <v-flex xs6>
            <h4>Date:</h4> {{ forms.date }}
          </v-flex>
        </v-card-title>
      </v-card>
      <v-container mt-2>
        <v-card dark>
          <v-card-text>
            <v-form ref="userInfo">
             <v-text-field label="Name" :value="forms.name" readonly></v-text-field>
                     <v-text-field label="Contact Number" v-model="contact" :rules="rules" required></v-text-field>
                         <v-text-field label="Email"  :value="forms.email"  readonly></v-text-field>
             <v-text-field label="Department"  :value="forms.department"  readonly></v-text-field>
             
             <v-text-field label="Staff ID"  :value="forms.id"  readonly></v-text-field>
         
             <v-text-field label="Gender" :value="forms.gender" readonly></v-text-field>
            </v-form>
          </v-card-text>
        </v-card>
      </v-container>
    </v-container>
  </v-app>
</template>
<script>
import moment from 'moment';
import db from '@/components/firebase.init';
export default {
  
  props:['forms','company'],
  
  data() {
             console.log(this.forms);
    return {
      
    
      window:{
          width: 0,
          height: 0
      }
    };
  },
  methods: {
      
      
    responsiveStyle() {
      return this.window.width >= 480 ? "width: 48%" : "";
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    validate(){
      return this.$refs.userInfo.validate()
    },

  },
  filters: {
    capitalize(value) {
      if (!value) {
        return "";
      }
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>
<style scoped>

h5{
  margin-bottom: 50px;
}
</style>




